import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  ApiCollectionResponse,
  ApiSingleResponse,
} from '../interfaces/responses/api-response';
import {
  CreatePaymentMethod,
  PaymentMethod,
  UpsertPaymentMethod,
} from '../interfaces/payment-method';

/**
 * Moyens de paiement de l'inscription en ligne.
 *
 * <p>Deux surfaces : l'administration voit tout (`/admin/payment-methods`),
 * l'élève qui doit payer ne voit que les moyens actifs — via l'endpoint
 * public, le même que celui du site vitrine, pour qu'il n'existe qu'une
 * source de coordonnées bancaires.</p>
 */
@Injectable({ providedIn: 'root' })
export class PaymentMethodService {
  private readonly http = inject(HttpClient);
  private readonly adminUrl = `${environment.BASE_URL}/admin/payment-methods`;
  private readonly publicUrl = `${environment.BASE_URL}/public/payment-methods`;

  /** Tous les moyens, actifs ou non — administration. */
  getAll(): Observable<ApiCollectionResponse<PaymentMethod>> {
    return this.http.get<ApiCollectionResponse<PaymentMethod>>(this.adminUrl);
  }

  /** Les seuls moyens actifs — ce que voit celui qui doit payer. */
  getActive(): Observable<ApiCollectionResponse<PaymentMethod>> {
    return this.http.get<ApiCollectionResponse<PaymentMethod>>(this.publicUrl);
  }

  create(
    dto: CreatePaymentMethod,
  ): Observable<ApiSingleResponse<PaymentMethod>> {
    return this.http.post<ApiSingleResponse<PaymentMethod>>(this.adminUrl, dto);
  }

  update(
    id: number,
    dto: UpsertPaymentMethod,
  ): Observable<ApiSingleResponse<PaymentMethod>> {
    return this.http.put<ApiSingleResponse<PaymentMethod>>(
      `${this.adminUrl}/${id}`,
      dto,
    );
  }

  delete(id: number): Observable<ApiSingleResponse<string>> {
    return this.http.delete<ApiSingleResponse<string>>(`${this.adminUrl}/${id}`);
  }
}
